<template>
    <Head title="Redemption Tracker" />
    <div class="px-4 md:px-8 gap-y-16 relative">
        <Trips />
    </div>
</template>
<script setup>
import { Head } from '@inertiajs/vue3';
import Trips from '@/components/trips/trips.vue';
</script>
